import { defineComponent as _defineComponent } from 'vue'
import type { Keyword } from '@ilteducation/content-ref-data-types';
import { computed, ref, watch } from 'vue';
import axios from 'axios';
import ImageUploader from '@/components/ImageUploader.vue';
import FormSaveButton from '@/components/base/FormSaveButton.vue';
import { useBabelfish } from '@/comp/use-babelfish';
import TranslationsTable from '@/components/base/TranslationsTable.vue';

type Props = {
  id?: string;
  title: string;
  item?: Keyword;
};

type KeywordModel = Partial<Keyword> & { categories?: string[] };


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item?: Keyword;
}



const notEmptyRule = ref((val: any) => (val || '').length > 0 || 'This field is required');
const noWhitespace = ref(
  (val: any) => (val || '').length === (val || '').trim().length || 'No whitespace at beginning or end allowed',
);

const imageItem = ref<any>(null);

watch(
  () => props.item,
  async (item) => {
    if (item && item.imageId) {
      try {
        const { data: contentImage } = await axios.get(
          `${process.env['VUE_APP_CONTENT-IMAGE_API_URL']}/${item.imageId}`,
        );
        imageItem.value = contentImage;
      } catch (e) {
        console.error('Image not found. Ignoring.', e);
        imageItem.value = { id: '' };
      }
    } else {
      imageItem.value = { id: '' };
    }
  },
  { immediate: true },
);

const { lokaliseProjectId, orderedLanguages } = useBabelfish();

const model = ref<KeywordModel>({
  imageId: props.item?.imageId,
  key: props.item?.key,
  active: true,
  language: 'en-gb',
  applications: ['manabua'],
});

const categoryChoices: Record<string, { value: string; text: string }[]> = {
  'learn-it': [
    { value: 'learn-it:healthcare', text: 'Learn-it: Healthcare' },
    { value: 'learn-it:childcare', text: 'Learn-it: Childcare' },
  ],
};

const availableCategories = computed(() =>
  (model.value.applications || []).flatMap((application) => categoryChoices[application] || []),
);

watch(
  () => model.value.applications,
  (applications) => {
    if (model.value.categories) {
      model.value.categories = model.value.categories.filter((category) =>
        (applications || []).includes(category.split(':')[0]),
      );
    }
  },
);

const imageUploader = ref<InstanceType<typeof ImageUploader> | null>(null);

const save = async () => {
  if (props.item && imageUploader.value?.hasChanged() && !model.value.imageId) {
    const {
      data: { id: imageId },
    } = await axios.post(`${process.env['VUE_APP_CONTENT-IMAGE_API_URL']}`, {
      type: 'ImageV1',
      realm: 'all',
      description: `keyword: ${props.item.key}`,
    });
    model.value.imageId = imageId;
    await imageUploader.value.defaultUpload(imageId);
  }
  imageUploader.value?.altText?.saveAltText(model.value.imageId);
};

const deleteImage = async () => {
  if (props.item && props.item.imageId) {
    model.value.imageId = '';
    imageItem.value = { id: '' };
  }
};

const pathOrder = ['title', 'description', 'descriptionLong'];

const lokaliseLink = computed(
  () => `https://app.lokalise.com/project/${lokaliseProjectId.value}/?view=multi&search=keyword::${props.item?.key}::`,
);

const videoFields = ref([
  { source: 'id', link: 'edit', label: 'ID', sortable: false },
  {
    source: 'title',
    sortable: true,
  },
  {
    source: 'market',
    label: 'Markets',
    sortable: true,
  },
  {
    source: 'filmId',
    sortable: true,
  },
]);

return { __sfc: true,props, notEmptyRule, noWhitespace, imageItem, lokaliseProjectId, orderedLanguages, model, categoryChoices, availableCategories, imageUploader, save, deleteImage, pathOrder, lokaliseLink, videoFields, ImageUploader, FormSaveButton, TranslationsTable }
}

})